import GoogleAnalyticsEvent from '@hooks/use-analytics/google-analytics-event';

export const useAnalytics = () => {
	const sendEvent = (event) => {
		if (!Array.isArray(window.dataLayer)) {
			console.warn('Error in useAnalytics(): dataLayer is not defined');
			return;
		}

		if (!(event instanceof GoogleAnalyticsEvent)) {
			console.warn(
				'Error in useAnalytics(): The event object must be an instance of `GoogleAnalyticsEvent`',
			);
			return;
		}

		window.dataLayer.push(event.getEvent());
	};

	return {
		sendEvent,
	};
};
